export class page{

    language:string;
    jou_uid:string;
    title:string;
    content:string;
    cat_id:string;
    content_type:string;
    result:string;
    page_type_code:string;
}